import { forwardRef } from 'react'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import ToggleButton from '@mui/material/ToggleButton'
import { Link, useI18next, useTranslation } from 'gatsby-plugin-react-i18next'

import Tooltip from 'components/Tooltip'

const buttonStyle = theme => ({
  width: theme.sizing.mdGridSize * 1.5,
  fontSize: 'caption.fontSize'
})

// eslint-disable-next-line react/display-name, react/prop-types
const TooltipToggleButton = forwardRef(({ tooltipProps, ...props }, ref) => (
  <Tooltip {...tooltipProps}>
    <ToggleButton ref={ref} {...props} />
  </Tooltip>
))

function LanguageSwitcher() {
  const { languages, language, originalPath } = useI18next()
  const { t } = useTranslation()

  return (
    <ToggleButtonGroup
      size="small"
      color="primary"
      value={language}
      exclusive
    >
      {languages.map(lang => (
        <TooltipToggleButton
          key={lang}
          value={lang}
          sx={buttonStyle}
          component={Link}
          to={originalPath}
          language={lang}
          tooltipProps={{
            title: t(`languages.${lang}`)
          }}
        >
          {lang}
        </TooltipToggleButton>
      ))}
    </ToggleButtonGroup>
  )
}

export default LanguageSwitcher
